import { useFloodJobs } from '@/features/analytics/context/FloodJobsContext';
import { SarJobResultModal } from '@/features/map/components/ui/SarJobResultModal';

/**
 * Global host for SAR job result modal (auto-open on mock completion + programmatic open from Pipeline).
 */
export function SarJobResultModalHost() {
  const { resultModalJob, dismissResultModal } = useFloodJobs();

  return (
    <SarJobResultModal
      open={Boolean(resultModalJob)}
      job={resultModalJob}
      onClose={dismissResultModal}
    />
  );
}
